var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.862 4C22.948 3.99975 22.2071 4.74043 22.2069 5.65415V26.3446C22.2069 27.2588 21.4659 27.9998 20.5517 27.9998H7.3103V5.65515C7.3103 4.74092 8.05148 4 8.96545 4H23.862Z",
    fill: "#3641EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.862 4C22.948 3.99975 22.2071 4.74043 22.2069 5.65415V26.3446C22.2069 27.2588 21.4659 27.9998 20.5517 27.9998H7.3103V22.5848C12.7869 19.2897 17.7069 13.4739 20.9707 4H23.862Z",
    fill: "#434AF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 25.5172H18.8966V26.3448C18.8966 27.2591 19.6375 28 20.5517 28H5.65515",
    fill: "#707FE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5171 6.48284H22.2068V5.65515C22.2068 4.74092 22.948 4 23.862 4C24.776 4 25.5171 4.74092 25.5171 5.65515V6.48284Z",
    fill: "#707FE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.313 7.494C16.6887 6.89928 15.9975 6.20783 15.4028 6.58376C15.2476 5.89754 14.27 5.89754 14.1151 6.58376C13.5204 6.20808 12.8289 6.89952 13.2049 7.494C12.5186 7.64915 12.5186 8.62677 13.2049 8.78167C12.8292 9.3764 13.5204 10.0678 14.1151 9.69192C14.2702 10.3781 15.2479 10.3781 15.4028 9.69192C15.9975 10.0676 16.6889 9.3764 16.313 8.78167C16.9992 8.62677 16.9992 7.6489 16.313 7.494Z",
    fill: "#FACB0A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6897 13.1035H16.8277V13.9312H12.6897V13.1035Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9312 11.4483H18.0691V12.276H13.9312V11.4483Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4483 11.4483H13.1034V12.276H11.4483V11.4483Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6206 15.1723H20.5517V16H10.6206V15.1723Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96545 15.1723H9.79315V16H8.96545V15.1723Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6206 16.8275H17.2412V17.6552H10.6206V16.8275Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0689 16.8275H20.5518V17.6552H18.0689V16.8275Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6206 18.4828H20.5517V19.3105H10.6206V18.4828Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96545 18.4828H9.79315V19.3105H8.96545V18.4828Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6206 20.138H13.1035V20.9657H10.6206V20.138Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9312 20.138H20.5517V20.9657H13.9312V20.138Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6206 21.7932H17.2412V22.6208H10.6206V21.7932Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96545 21.7932H9.79315V22.6208H8.96545V21.7932Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6206 23.4483H20.5517V24.276H10.6206V23.4483Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0689 21.7932H20.5518V22.6208H18.0689V21.7932Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1034 8.96545C24.4179 8.96545 23.862 9.52115 23.862 10.2069V23.4483H26.3448V10.2069C26.3448 9.5214 25.7892 8.96545 25.1034 8.96545Z",
    fill: "#DC3A41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4137 16H27.586V11.4483C27.5858 11.2198 27.4005 11.0348 27.1723 11.0345H23.862V10.2068H27.1723C27.8575 10.2076 28.413 10.763 28.4137 11.4483V16Z",
    fill: "#FACB0A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.862 23.4483L25.1034 25.9311L26.3448 23.4483H23.862Z",
    fill: "#FACB0A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.862 14.3448H26.3448V15.1725H23.862V14.3448Z",
    fill: "#FACB0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.e7af49ef02821a2a5fa08f12d00814a8.svg";
export { ForwardRef as ReactComponent };